// extracted by mini-css-extract-plugin
module.exports = {"progress":"Alarms_progress__lVsQQ","alarmButton":"Alarms_alarmButton__1ZU_V","alarmButtonText":"Alarms_alarmButtonText__2cIs1"};